module.exports = "https://static.im-cdn.com/mjc/storefront/Florencia/static/media/ArrowRight.3cab97ae.svg";